import styled from "styled-components";
import { Breadcrumb, Menu } from "antd";

export const Container = styled.div`
  padding: 0px 30px;
  height: 60px;
  display: flex;
  align-items: center;
  .ant-dropdown-arrow {
    margin-top: 80px !important;
  }
  .logo-img {
    margin-right: 20px;
    /* width: 160px; */
  }
  /* background-color: ${(props) => props.theme.colors.subHeaderBg}; */
`;
export const DropdownTitle = styled.div`
  margin-right: 30px;
  font-size: 14px;
  font-weight: 500;
  color: #000;
  text-transform: capitalize;
  cursor: pointer;

  @media ${(props) => props.theme.device.tablet} {
    margin-right: 15px;
  }
`;
export const SubMenuTitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  :hover {
    transition: 0.3s ease-in-out;
    margin-left: 5px;
  }
`;

export const MenuContainer = styled(Menu)`
  margin-top: 18px;
  max-width: 100%;
  width: 200px;
  box-shadow: 0 0 3px rgb(0 0 0 / 10%) !important;

  .ant-menu-vertical .ant-menu-item:not(:last-child),
  .ant-menu-vertical-left .ant-menu-item:not(:last-child),
  .ant-menu-vertical-right .ant-menu-item:not(:last-child),
  .ant-menu-inline .ant-menu-item:not(:last-child) {
    border-bottom: 1px solid #50505033 !important;
    margin-bottom: 0px !important;
  }
`;
export const Block = styled.div`
  width: 100%;
  float: right;
  /* display: flex */
  /* width: 100%; */
  /* height: 100% */
`;

export const Xbreadcrumb = styled(Breadcrumb)`
  .ant-breadcrumb-link a,
  .ant-breadcrumb-link,
  .ant-breadcrumb-separator {
    color: white !important;
  }
`;

export const Title = styled.h1`
  margin: 0;
  color: #000;
  font-size: 20px;
  font-weight: 600;
  @media ${(props) => props.theme.device.tablet} {
    font-size: 14px;
  }
  @media ${(props) => props.theme.device.mobileL} {
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90px;
  }
  @media (max-width: 320px) {
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90px;
  }
`;
export const Email = styled.label`
  display:flex;
  align-items: center;
  margin-bottom:0;
  font-size: 14px;
  line-height: 30px;
  @media ${(props) => props.theme.device.tablet} {
    font-size: 12px;
  }
  @media ${(props) => props.theme.device.mobileXL} {
    font-size: 10px;
  }
  @media (max-width: 360px) {
    display: none;
  }
`;

export const BurgerButton = styled.div`
  margin-right: 10px;
  margin-top: -7px;
  font-size: 18px;
  font-weight: 500;
  color: #000;
  display: none;
  height:19px !important;
  @media ${(props) => props.theme.device.responsive} {
    display: block;
  }
  @media (max-width: 281px) {
    margin-right: 15px;
  }
`;
